<template>
  <div class="accordion-section__container">
    <div
      v-for="index of columnCount"
      :key="index"
      class="accordion-section__accordion"
    >
      <accordion
        :heading-element="title === '' ? 'h2' : 'h3'"
        block-class="accordion-section"
        :accordion-data="getBlocksPerColumn(index - 1)"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Accordion (accordion-section)
 * -----------------------------------------------------------------------------
 * Accordion section component.
 * - Static section.
 *
 */
import Accordion from '~global/accordion-snippet/accordion-snippet'

export default {
  name: 'AccordionSection',

  components: {
    Accordion,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    columnCount: {
      type: Number,
      default: 0,
    },
    itemCountPerColumn: {
      type: Number,
      default: 0,
    },
    blocks: {
      type: Array,
      default: () => [],
    },
  },

  methods: {

    getBlocksPerColumn(columnIndex) {
      const startIndex = columnIndex * this.itemCountPerColumn
      const rowEndIndex = (columnIndex + 1) * this.itemCountPerColumn
      const endIndex = rowEndIndex > this.blocks.length ? this.blocks.length : rowEndIndex

      return this.blocks.slice(startIndex, endIndex)
    },

  },

}
</script>

<style lang="scss">
@import './accordion-section';
</style>
